import { FundriseRouteConfig } from 'vue-router';
import VcxArticle from '@views/vcx/vcx-article-view.vue';
import VcxLanding from '@views/vcx/vcx-landing-view.vue';

const vcxRoutes: Array<FundriseRouteConfig> = [
	{
		path: '/vcx',
		name: 'vcx-landing',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: VcxLanding
	},
	{
		path: `/vcx/newsroom`,
		name: 'vcx-newsroom',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		redirect: { name: 'blog-category', params: { categoryUrlSlug: 'vcx' } }
	},
	{
		path: `/vcx/newsroom/:blogPostUrlSlug`,
		name: 'vcx-blog-post',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: VcxArticle
	}
];

export default vcxRoutes;
